import React from "react";
import { Space, Tag } from "antd";

type Props = {
  name: React.ReactNode;
  isList?: boolean;
};

/**
 * A target's name, badged when it is a single transactional list rather than a
 * brand. Brands and lists sit together in one dropdown and read alike once
 * chosen, so the badge is the only thing saying which was picked.
 */
const TargetLabel: React.FC<Props> = ({ name, isList }) => (
  <Space size={4}>
    {name}
    {isList && (
      <Tag color="blue" style={{ marginInlineEnd: 0 }}>
        List
      </Tag>
    )}
  </Space>
);

export default TargetLabel;
